// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__23m4-","log":"ModalInventoryLogs_log__CYhnM","date":"ModalInventoryLogs_date__338RC","userName":"ModalInventoryLogs_userName__37myB"};